/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_New_PhotoInputs */

const en_sync_new_photo = /** @type {(inputs: Sync_New_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync New Photo`)
};

const es_sync_new_photo = /** @type {(inputs: Sync_New_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar nueva foto`)
};

const fr_sync_new_photo = /** @type {(inputs: Sync_New_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchroniser la nouvelle photo`)
};

const de_sync_new_photo = /** @type {(inputs: Sync_New_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Foto synchronisieren`)
};

const ja_sync_new_photo = /** @type {(inputs: Sync_New_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい写真を同期`)
};

const zh_sync_new_photo = /** @type {(inputs: Sync_New_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同步新照片`)
};

const ar_sync_new_photo = /** @type {(inputs: Sync_New_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مزامنة صورة جديدة`)
};

const id_sync_new_photo = /** @type {(inputs: Sync_New_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinkronkan Foto Baru`)
};

const it_sync_new_photo = /** @type {(inputs: Sync_New_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizza Nuova Foto`)
};

const ru_sync_new_photo = /** @type {(inputs: Sync_New_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизировать новое фото`)
};

const pt_sync_new_photo = /** @type {(inputs: Sync_New_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizar Nova Foto`)
};

const ko_sync_new_photo = /** @type {(inputs: Sync_New_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 사진 동기화`)
};

/**
* | output |
* | --- |
* | "Sync New Photo" |
*
* @param {Sync_New_PhotoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sync_new_photo = /** @type {((inputs?: Sync_New_PhotoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_New_PhotoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sync_new_photo(inputs)
	if (locale === "es") return es_sync_new_photo(inputs)
	if (locale === "fr") return fr_sync_new_photo(inputs)
	if (locale === "de") return de_sync_new_photo(inputs)
	if (locale === "ja") return ja_sync_new_photo(inputs)
	if (locale === "zh") return zh_sync_new_photo(inputs)
	if (locale === "ar") return ar_sync_new_photo(inputs)
	if (locale === "id") return id_sync_new_photo(inputs)
	if (locale === "it") return it_sync_new_photo(inputs)
	if (locale === "ru") return ru_sync_new_photo(inputs)
	if (locale === "pt") return pt_sync_new_photo(inputs)
	return ko_sync_new_photo(inputs)
});